import controls      from './controls';
import remote        from './remote';

export default {

	...controls,
	...remote

};
